(() => {
  const rootSelector = '[data-armor-install-v2]';
  const controllers = new WeakMap();
  const youtubeIdPattern = /^[A-Za-z0-9_-]{11}$/;

  class ArmorInstallV2 {
    constructor(root) {
      this.root = root;
      this.handleClick = this.handleClick.bind(this);
      this.root.addEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const button = event.target.closest('[data-armor-install-load]');
      if (!button || !this.root.contains(button)) return;

      const video = button.closest('[data-armor-install-video]');
      const player = video?.querySelector('[data-armor-install-player]');
      const panel = video?.querySelector('[data-armor-install-panel]');
      const status = video?.querySelector('[data-armor-install-status]');
      const videoId = video?.dataset.videoId || '';
      const videoTitle = video?.dataset.videoTitle || 'Armor-Dilloz installation video';

      if (
        !video ||
        !player ||
        !panel ||
        !status ||
        !youtubeIdPattern.test(videoId) ||
        video.dataset.videoLoaded === 'true'
      ) {
        return;
      }

      button.disabled = true;

      const iframe = document.createElement('iframe');
      iframe.className = 'armor-install-v2__video-iframe';
      iframe.title = `YouTube video: ${videoTitle}`;
      iframe.src =
        `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}` +
        '?autoplay=0&cc_load_policy=1&playsinline=1&rel=0';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allow = 'encrypted-media; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.tabIndex = 0;
      iframe.addEventListener('focus', () => {
        iframe.classList.add('armor-install-v2__video-iframe--focused');
      });
      iframe.addEventListener('blur', () => {
        iframe.classList.remove('armor-install-v2__video-iframe--focused');
      });

      video.dataset.videoLoaded = 'true';
      panel.hidden = true;
      player.appendChild(iframe);
      status.textContent =
        'Video player loaded. Playback remains stopped. Use the player play control to begin.';
      iframe.focus({ preventScroll: true });
      iframe.classList.toggle(
        'armor-install-v2__video-iframe--focused',
        document.activeElement === iframe
      );
    }

    destroy() {
      this.root.removeEventListener('click', this.handleClick);
      this.root.querySelectorAll('.armor-install-v2__video-iframe').forEach((iframe) => {
        iframe.remove();
      });
      this.root.querySelectorAll('[data-armor-install-video]').forEach((video) => {
        delete video.dataset.videoLoaded;
        const panel = video.querySelector('[data-armor-install-panel]');
        const button = video.querySelector('[data-armor-install-load]');
        const status = video.querySelector('[data-armor-install-status]');

        if (panel) panel.hidden = false;
        if (button) button.disabled = false;
        if (status) status.textContent = '';
      });
    }
  }

  function findRoots(container) {
    const roots = [];
    if (container.matches?.(rootSelector)) roots.push(container);
    container.querySelectorAll?.(rootSelector).forEach((root) => roots.push(root));
    return roots;
  }

  function initialize(container = document) {
    findRoots(container).forEach((root) => {
      if (!controllers.has(root)) {
        controllers.set(root, new ArmorInstallV2(root));
      }
    });
  }

  function unload(container) {
    findRoots(container).forEach((root) => {
      const controller = controllers.get(root);
      if (!controller) return;
      controller.destroy();
      controllers.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
